import { collection, getDoc, getDocs } from "firebase/firestore";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getUserDoc,
  contentsCollectionRef,
  getContentDoc,
} from "../utils/firestoreHelpers";
import { useEffect } from "react";
import dateFormat from "dateformat";

const BusinessDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [content, setContent] = useState({});
  const [usersData, setUsersData] = useState([]);
  const [usersDataNotInterested, setUsersDataNotInterested] = useState([]);
  const [interestType, setInterestType] = useState("interested");

  const getData = async () => {
    try {
      const contentDataRef = await getContentDoc(params.id);
      const contentData = (await getDoc(contentDataRef))?.data() || {};
      // console.log("contentData :: ", contentData);
      setContent(contentData);

      const subcollectionRef_interested = collection(
        contentsCollectionRef,
        params.id,
        "interested"
      );
      const querySnapshot = await getDocs(subcollectionRef_interested);

      const usersData = [];

      for (const doc of querySnapshot.docs) {
        let userId = doc.data()?.id;
        let userDocRef = getUserDoc(userId);
        let userDataSnapshot = await getDoc(userDocRef);
        // console.log("userDataSnapshot :: ", userDataSnapshot.data());
        if (![undefined, "undefined", null].includes(userDataSnapshot.data())) {
          usersData.push({ ...userDataSnapshot.data(), id: userId });
        }
      }
      setUsersData(usersData);

      // NOT INTERESTED
      const subcollectionRef_not_interested = collection(
        contentsCollectionRef,
        params.id,
        "not_interested"
      );
      const querySnapshot1 = await getDocs(subcollectionRef_not_interested);

      const usersData1 = [];

      for (const doc of querySnapshot1.docs) {
        let userId = doc.data()?.id;
        let userDocRef = getUserDoc(userId);
        let userDataSnapshot = await getDoc(userDocRef);
        // console.log("userDataSnapshot :: ", userDataSnapshot.data());
        if (![undefined, "undefined", null].includes(userDataSnapshot.data())) {
          usersData1.push({ ...userDataSnapshot.data(), id: userId });
        }
      }
      setUsersDataNotInterested(usersData1);

      // console.log("Users Data:", usersData, usersData1);
    } catch (error) {
      console.error("Error getting data:", error.message);
    }
  };

  const handleBackButton = (event) => {
    // Prevent the default behavior of the back button
    event.preventDefault();
    return;

    // Optionally, you can perform some action here or show a message
    // console.log("Back button is blocked");
  };

  useEffect(() => {
    getData();
    // Add the event listener when the component mounts
    window.addEventListener("popstate", handleBackButton);

    return () => {
      // Remove the event listener when the component unmounts
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  return (
    <>
      <header className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
      <div className="flex items-center gap-3">
        {/* Minimalist Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="p-2 -ml-2 rounded-full hover:bg-gray-100 text-gray-600 transition-colors"
          aria-label="Go back"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>

        <h4 className="text-xl font-bold text-gray-800 m-0">
          Business Content Details -
        </h4>
      </div>

    </header>
      <div>
        <div className="w-100 d-flex gap-3 align-items-top">
          <img
            alt=""
            className="w-45 object-fit-cover"
            style={{ maxHeight: "250px" }}
            src={content?.image_url}
          />
          <div className="w-45 d-flex flex-column gap-3">
            <div>TITLE - {content?.title}</div>
            <div>TYPE - {content?.type}</div>
            <div>LINK - {content?.link}</div>
            <div>
              FROM -{" "}
              {dateFormat(Date(content?.date_from), "dddd, mmmm dS, yyyy")}
            </div>
            <div>
              TO - {dateFormat(Date(content?.date_to), "dddd, mmmm dS, yyyy")}
            </div>
            <div>DESCRIPTION - {content?.description}</div>
            <div>VENUE - {content?.venue}</div>
            <div>TERMS AND CONDITIONS - {content?.tnc}</div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end mt-3">
        <select onChange={(e) => setInterestType(e.target.value)}>
          <option value="interested">Interested</option>
          <option value="not_interested">Not Interested</option>
        </select>
      </div>
      <div className="mt-3">
        {(interestType === "interested" ? usersData : usersDataNotInterested)
          ?.length ? (
          <>
            <h5>Users input - </h5>
            <table className="table">
              <thead className="table-secondary">
                <tr>
                  <th className=""></th>
                  <th className="">First Name</th>
                  <th className="">Last Name</th>
                  <th className="">Designation</th>
                  <th className="">Email</th>
                  <th className="">Company</th>
                  <th className="">Dial code</th>
                  <th className="">Contact No</th>
                  <th className="">Membership</th>
                </tr>
              </thead>
              <tbody>
                {(interestType === "interested"
                  ? usersData
                  : usersDataNotInterested
                )?.length < 1 ? (
                  <tr>
                    <td colSpan={10} className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : null}
                {(interestType === "interested"
                  ? usersData
                  : usersDataNotInterested
                )?.map((data, index) => {
                  const d = data;
                  const { id } = data;
                  // console.log("user id :: ", id);
                  return (
                    <tr key={id}>
                      <td className="">{index + 1}</td>
                      <td className="">{d.first_name}</td>
                      <td className="">{d.last_name}</td>
                      <td className="">{d.designation}</td>
                      <td className="">{d.email}</td>
                      <td className="">{d.company}</td>
                      <td className="">{d.mobile_number_dial}</td>
                      <td className="">{d.mobile_number}</td>
                      <td className="">{d.membership_tier}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <h2>No users to display</h2>
        )}
      </div>
    </>
  );
};

export default BusinessDetail;
